export var IS_BANNER_ENABLED_DEFAULT = false;
